export enum DisplaySubscriptionStatusEnums {
  INACTIVE = 'INACTIVE',
  STANDARD = 'STANDARD',
  PRO = 'PRO'
}
